export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8690.e4d615ef.jpg";